export default "__VITE_ASSET__DrlKFInf__"